module.exports = __webpack_public_path__ + "img/Mockup_ocho.5886d842.png";